import styled from "styled-components";
import AntButton from "uiKits/Button";
import { CONTENT_WIDTH, media, PAGE_GUTTER } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  text-align: center;
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 24px ${PAGE_GUTTER.desktop}px 48px;

  ${media.downTablet`
    padding: 20px ${PAGE_GUTTER.tablet}px 40px;
  `}

  ${media.downMobile`
    padding: 16px ${PAGE_GUTTER.mobile}px 32px;
  `}
`;

export const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
`;

export const StyledHeading = styled.h2`
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 16px 0;

  ${media.downTablet`
    font-size: 28px;
  `}

  ${media.downMobile`
    font-size: 22px;
    line-height: 1.3;
  `}
`;

export const StyledButton = styled(AntButton)`
  min-height: 44px;
  height: 50px;
  width: min(100%, 500px);
  max-width: 100%;
`;
